import $ from 'jquery'
import { detectTheme, setTheme, userColorTheme, updateUserColorTheme } from '../layout/theme.js'

const theme = detectTheme();
if (SOPHIA.loggedIn() || $('body').hasClass('themed')) setTheme(theme);
if (SOPHIA.loggedIn() && !userColorTheme()) updateUserColorTheme(theme);
